export default "__VITE_ASSET__BNi3utj$__"